import React, { createContext, useState } from "react";
const placeholderImage = require('../Images/image_generation_placeholder.jpg')
  
export const StoryboardStateContext = createContext(); 

export const StoryboardStateProvider = ({ children }) => {
  const [storyboardState, setStoryboardState] = useState({projectTitle:'Untitled Project', projectId:1, storyboard:[{image:placeholderImage, itemPrompt:'', selectedCharacter:'None', label:'', notes:''}, {image:placeholderImage, itemPrompt:'', selectedCharacter:'None',label:'', notes:''}, {image:placeholderImage, itemPrompt:'', selectedCharacter:'None',label:'', notes:''}], shotList:[{"Shot Number": '', "Description/Action":'', "Shot Type": '', "Shot Type": '', "Camera Movement":'', "Location":'', "Notes":'' }]}) // each storyboardState item should be strutured as {image:image, itemPrompt: itemPrompt, selectedCharacter:selectedCharacter,label:'', notes:''}

  return (
    <StoryboardStateContext.Provider value={{ storyboardState, setStoryboardState}}>
      {children} 
    </StoryboardStateContext.Provider>
  );
};
